<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .page-type-homepage_sante
        .title--2
            &:before
                background: $color-blue
        .title--5
            &:before
                background: $color-blue

        .list-select a.bk-like-label.bk-active
            background: $color-blue !important

        form .list-select a.bk-like-label:hover
            background: $color-blue !important

        .button
            &:not(.button--black)
                background: $color-blue !important
                &:hover
                    background: #208f96 !important

    .node-liste-articles

        .block-breadcrumb
            padding-top: 6rem
            +media("<=tablet")
                padding-top: 2rem


        &__header
            +container
            padding-top: 5.9375rem !important
            padding-bottom: 2.8125rem !important
            +media("<tablet")
                padding-top: 3.75rem !important
                padding-bottom: 1.875rem !important

        .title--2
            margin-bottom: 0
            line-height: 1.6

        &__content
            position: relative
            background-color: #f7f7f7
            margin: 0 auto
            padding: 1.875rem 7rem
            max-width: 100%


        .actus
            padding: 0 0 5.9375rem 0
            max-width: none
            +media("<tablet")
                padding: 0 0 3.75rem 0

        .actus__items
            margin-top: 0
            margin-bottom: 0

        .actus__items
            min-width: auto

        form
            margin-bottom: 2.8125rem
            background-color: #f7f7f7
            +media("<tablet")
                margin-bottom: 1.875rem
            .list-select
                +container
                padding-top: 2.5rem !important
                padding-bottom: 1.5625rem !important
                +media("<tablet")
                    max-width: unset
                    padding: 0.938rem
                    padding-top: 0.9375rem !important
                    padding-bottom: 0 !important

                ul
                    display: flex
                    flex-flow: row wrap
                    justify-content: flex-start
                    align-items: flex-start
                    list-style-type: none
                    // padding: 0 1.875rem 0 0
                    margin: 0

                    +media("<tablet")
                        padding: 0 0.9375rem 0 0

                    li
                        margin: 0 0.9375rem 0.9375rem 0

                        +media("<tablet")
                            margin: 0 0.9375rem 0.9375rem 0

                a.bk-like-label
                    display: inline-block
                    position: relative
                    padding: 10px 20px
                    margin: 0
                    cursor: pointer
                    font-size: 14px
                    font-weight: normal
                    line-height: inherit
                    background-color: #D0D0D0
                    border-radius: 21px
                    transition: .3s

                    &:hover
                        background-color: $color-base
                        color: $color-white


                a.bk-like-label.bk-active
                    background-color: $color-base
                    color: $color-white

        // Article list
        .views-infinite-scroll-content-wrapper
            +container
            padding-top: 0 !important
            padding-bottom: 0.8125rem !important
            max-width: 71.75rem
            margin-top: 2.8125rem
            +media("<=1000px")
                padding-bottom: 1.8125rem !important
            +media("<tablet")
                padding-bottom: 0.875rem !important


        .actus
            &__item
                &__dummy
                    &:hover
                        + .actus__item__content
                            .actus__item__title
                                .title--3
                                        color: $color-base
                &__tag
                    color: $color-base

                    &:hover
                        text-decoration: underline

                &__title
                    &:hover .title--3
                            color: $color-base

        // Show more btn
        .pager
            margin: 0
            .button
                background: $color-base
                color: white
                &:focus,
                &:hover
                    background: darken($color-base, 5)

        .views-element-container
            +media("<desktop")
                .js-pager__items
                    padding: 0 4em
                    +media("<tablet")
                        padding: 0 3em
                    .pager__item
                        width: 100%
                        a
                            width: 100%

</style>

<script>
    import $ from "jquery";

    function initBigArticles() {
      $('.views-infinite-scroll-content-wrapper > div:nth-of-type(10n + 1)').find('.actus__item').addClass('first last');
      $('.views-infinite-scroll-content-wrapper > div:nth-of-type(10n + 7)').find('.actus__item').addClass('first last');
    };

    $(window).on('load', () => {
        initBigArticles();

        $(".views-element-container").bind("DOMSubtreeModified", function() {
          initBigArticles();
        });
    });

    export default {
      name: "NodeListeArticles",
    };
</script>
